import { ImageList, ImageListItem, Paper, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

import { RepairOrderMediaEntry } from '../../sdk'

interface Props {
  media: RepairOrderMediaEntry[]
}

const RepairOrderMediaList: FunctionComponent<Props> = ({ media }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        boxSizing: 'border-box'
      }}>
      <Typography variant="h2">Media Gallery</Typography>
      <ImageList>
        {media.map((entry) => (
          <ImageListItem key={entry.id}>
            <img
              src={entry.thumbnailUrl!}
              alt={entry.info!.description}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Paper>
  )
}

export default RepairOrderMediaList
